var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex algin-center"},[_c('div',{staticClass:"mr-2",class:{ 'red--text': !_vm.enabled }},[_vm._v(" "+_vm._s(_vm.enabled ? 'Enabled' : 'Disabled')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }